import { render } from "./confirmOrder.vue?vue&type=template&id=6250cdf2&scoped=true"
import script from "./confirmOrder.vue?vue&type=script&lang=js"
export * from "./confirmOrder.vue?vue&type=script&lang=js"

import "./confirmOrder.vue?vue&type=style&index=0&id=6250cdf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6250cdf2"]])

export default __exports__